import { ToastContainer, toast } from 'react-toastify';
import DatePicker from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState, useRef } from 'react';
import { Cookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { ExportData } from '../../Exports/Export';
import { ClearSession } from '../../Common/Common'
import * as XLSX from 'xlsx';

import UploadDataReportTable from './UploadDataReportTable';
import Footer from '../../Layout/FooterComponent';
import { Autocomplete, TextField } from '../../../../node_modules/@mui/material/index';



const cookies = new Cookies();


const UploadDataReportForm = () => {

    useEffect(() => {
        document.title = 'UploadData Report'
    }, [])

    const [isLoading, setIsLoading] = useState(false);
    const [ColoredRow, setColoredRow] = useState('');
    const [tableData, setTableData] = useState([])
    const [eventCodeDropdown, setEventCodeDropdown] = useState([])
    const [VenueCodeDropdown, setVenueCodeDropdown] = useState([])
    const [CustodianDropdown, setCustodianDropDown] = useState([])
    const [DistrictDropdown, setDistrictDropdown] = useState([])
    const [ToDate, setToDate] = useState('');
    const [FromDate, setFromDate] = useState('');
    const [userCodedropdown, setUserCode] = useState([])
    
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [SessionClear, SetSessionClear] = useState(false);
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
    })
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        EventCode: '',
        UserCode:'',
        FromDate: '',
        ToDate: '',
        VenueCode: '',
        CustodianCode: '',
        DistrictCode: '',
        TrunkID: '',
        VehicleID: '',

    });
    const inputRefs = useRef([]);
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')

    const userCodeDropdownList = async () => {
        let Condition = " And UserGroupID In(3,4)";
        let TextPart = "UserName"
        let ValuePart = "UserCode"
        let TableName = "UserMaster"
        let data = { Token, LoginUserCode,  Condition, TextPart, ValuePart, TableName }
        await fetch('/api/User/BindDropDownList',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                if (res.status === "SUCCESS") {
                    setUserCode(res.dropDownList);
                }
                else if (res.message === "EXPIRED") {
                    navigate("/login")
                    SetSessionClear(true);
                }
                else if (res.message !== "") {
                    toast.error(res.message, {

                    })
                }

            }).catch((err) =>
                toast.error(err.message, {
                    position: 'top-center'
                })
            );

    };
    const handleClear = () => {
        setFormData({
            EventCode: '',
            UserCode: '',
            FromDate: '',
            ToDate: '',
            VenueCode: '',
            CustodianCode: '',
            DistrictCode: '',
            TrunkID: '',
            VehicleID: '',
        });
        setColoredRow(null)
        setTableData([])
        inputRefs.current['ddlEventCode'].focus();

    }
    const EventDropdownList = async () => {

        let data = { Token, LoginUserCode }
        await fetch('/api/MasterController/GetEvent',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setEventCodeDropdown(res.eventList);
            }).catch((err) => console.log(err));

    };
    const DistrictDropdownList = async (eventCode) => {


        let data = {
            Token, LoginUserCode, eventCode, Type: 'GetDistrict'
        }
        await fetch('/api/MasterController/GetVenue',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setDistrictDropdown(res.district);
            }).catch((err) => console.log(err));

    };

    const CustodianDropdownList = async (eventCode, District) => {


        let data = { Token, LoginUserCode, eventCode, District }
        await fetch('/api/MasterController/GetCustodian',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setCustodianDropDown(res.custodianList);

            }).catch((err) => console.log(err));

    };
    const VenueDropdownList = async (eventCode, District) => {
        let data = {
            Token, LoginUserCode, eventCode, District, Type: 'GetVenue'
        }
        await fetch('/api/MasterController/GetVenue',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setVenueCodeDropdown(res.venueList);
            }).catch((err) => console.log(err));

    };

    const handleSubmit = async (CurrentPage) => {
        setIsLoading(true)
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let data = {
            ...filterData,
            ...formData, Token, LoginUserCode, FromDate: document.getElementById('txtfromDate').value, ToDate
                : document.getElementById('txtDateTo').value,
            Type: 'S',
            PageIndex: `${PageIndex}`

        }
        await fetch(`/api/ReportController/UploadDataReport`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                setTableData(responseData);
            } else if (responseData.message === "EXPIRED") {
                ClearSession();
            }

            else if (responseData.status === "ERROR") {
                toast.error(responseData.message, {

                })
                setTableData([])
                inputRefs.current[responseData.focus].focus()

            }
            setIsLoading(false);
        }).catch((err) => {
            toast.error(err.message, {

            })
            setIsLoading(false)
        }, [filterData])
    };
    const handleChange1 = (event, value) => {
        handleSubmit(value)
    };
    const handleClick = async (trukId) => {
        window.open(`/TrackingTrunk?trunK_ID=${trukId}`)
      
    }
    const downloadExcel = (records) => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
            [records.hSrNo, records.hevent, records.hvenue, records.hcustodian, records.hdistrict,
            records.htrunkid, records.hcreatedby, records.hcreateddate,
            records.hcsC_REPMOBILE, records.hcsC_REPRESETATIVE,
            records.hcustodiaN_EMAILID, records.hdM_EMAIL, records.hdrivermobile, records.hqrCode, records.hvehicleid, records.hvehiclenumber, records.hvenuE_CONTACT_PERSON, records.hvenuE_EMAIL, records.hvenuE_MOBILE]
            ,
            ...records.getUploadData?.map((records) => [records.srNo, records.event, records.venue, records.custodian, records.district,
            records.trunK_ID, records.createdby, records.createddate, records.csC_REPMOBILE,
            records.csC_REPRESETATIVE, records.custodiaN_EMAILID, records.dM_EMAIL, records.drivermobile,
            records.qrCode, records.vehicleid, records.vehiclenumber, records.venuE_CONTACT_PERSON, records.venuE_EMAIL, records.venuE_MOBILE,
            ]),
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'UploadDataReport.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadExcel = async () => {
        const apiUrl = `/api/ReportController/UploadDataReport`;
        const requestBody = {
            ...filterData, ...formData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        const records = await ExportData(apiUrl, requestBody, requestHeaders);
        if (records) {
            downloadExcel(records);

        }
    };

    useEffect(() => {
        inputRefs.current['ddlEventCode'].children[0].children[0].focus()
        EventDropdownList()
        userCodeDropdownList()
    }, [])

    useEffect(() => {

    }, [])

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Upload Data Report'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Event<span className="Required">*</span></label>
                                            <Autocomplete
                                                value={eventCodeDropdown?.find((item) => item?.eventCode === formData?.EventCode) || null}
                                               

                                                onChange={(event, newValue) => {
                                                    setFormData({ ...formData, EventCode: newValue?.eventCode || '' });
                                                    DistrictDropdownList(newValue?.eventCode && newValue?.eventCode ? newValue?.eventCode : '');
                                                    CustodianDropdownList(newValue?.eventCode && newValue?.eventCode ? newValue?.eventCode : '','');
                                                    VenueDropdownList(newValue?.eventCode && newValue?.eventCode ? newValue?.eventCode : '', '');

                                                }}
                                                options={eventCodeDropdown || []}
                                                getOptionLabel={(option) => ` ${option.eventName}` || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        ref={ref => (inputRefs.current['ddlEventCode'] = ref)}
                                                        id="ddlEventCode"
                                                        style={{ backgroundColor: 'white' }}
                                                        placeholder="Event"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['txtfromDate'].children[0].children[0].focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-2  col-md-4 col-sm-6 ">
                                        <div className="fields ">
                                            <label className="form-label">Date </label>
                                            <DatePicker
                                                selected={FromDate}
                                                ref={ref => (inputRefs.current['txtfromDate'] = ref)}
                                                id='txtfromDate'
                                                className="form-control"
                                                placeholderText='From Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => setFromDate(date)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtDateTo'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <DatePicker
                                                selected={ToDate}
                                                ref={ref => (inputRefs.current['txtDateTo'] = ref)}
                                                id='txtDateTo'
                                                className="form-control"
                                                placeholderText='To Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => setToDate(date)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['ddlDistrictCode'].children[0].children[0].focus()
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">District</label>
                                            <Autocomplete
                                                value={DistrictDropdown?.find((item) => item?.districtCode === formData?.DistrictCode) || null}

                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, DistrictCode: newValue?.districtCode || '' })
                                                    CustodianDropdownList(formData.EventCode, newValue?.districtCode || '');
                                                    VenueDropdownList(formData.EventCode, newValue?.districtCode || '');
                                                }}
                                                options={DistrictDropdown || []}
                                                getOptionLabel={(option) => ` ${option.districtName}` || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        ref={ref => (inputRefs.current['ddlDistrictCode'] = ref)}
                                                        id="ddlDistrictCode"
                                                        style={{ backgroundColor: 'white' }}
                                                        placeholder="District"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['ddlCustodian'].children[0].children[0].focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                   
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Custodian</label>
                                            <Autocomplete
                                                value={CustodianDropdown?.find((item) => item?.custodianCode === formData?.CustodianCode) || null}

                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, CustodianCode: newValue?.custodianCode || '' })

                                                }}
                                                options={CustodianDropdown || []}
                                                getOptionLabel={(option) => option.custodianName || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        ref={ref => (inputRefs.current['ddlCustodian'] = ref)}
                                                        id="ddlCustodian"
                                                        style={{ backgroundColor: 'white' }}
                                                        placeholder="Custodian"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['ddlVenue'].children[0].children[0].focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">

                                        <div className="fields">
                                            <label className="form-label"> Venue</label>
                                            <Autocomplete
                                                // value={formData.VenueCode}
                                               
                                                value={VenueCodeDropdown?.find((item) => item?.venueCode === formData?.VenueCode) || null}
                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, VenueCode: newValue?.venueCode || '' })

                                                }}
                                                options={VenueCodeDropdown || []}
                                                getOptionLabel={(option) => option.venueName || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        ref={ref => (inputRefs.current['ddlVenue'] = ref)}
                                                        id="ddlVenue"
                                                        style={{ backgroundColor: 'white' }}
                                                        placeholder="Venue"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputRefs.current['txtTrunkId'].focus();
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>

                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Trunk ID</label>
                                            <input
                                                ref={ref => (inputRefs.current['txtTrunkId'] = ref)}
                                                id="txtTrunkId"
                                                type="text"
                                                className="form-control"
                                                placeholder="Trunk ID"
                                                autoComplete="off"
                                                maxLength='15'
                                                name='TrunkID'
                                                value={formData.TrunkID}
                                                onChange={(e) => {


                                                    setFormData({ ...formData, TrunkID: e.target.value })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['ddlUserCode'].children[0].children[0].focus()
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">User</label>
                                            <Autocomplete
                                                ref={ref => (inputRefs.current['ddlUserCode'] = ref)}
                                                id="ddlUserCode"
                                                value={userCodedropdown?.find((item) => item?.valuePart === formData?.UserCode) || null}
                                                onChange={(e, newValue) => {
                                                    setFormData({ ...formData, UserCode: newValue?.valuePart || '' })

                                                }}
                                                options={userCodedropdown || []}
                                                getOptionLabel={(option) => ` ${option.textPart}` || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        style={{ backgroundColor: 'white' }}
                                                        placeholder="User"
                                                        variant="outlined"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                handleSubmit()
                                                            }
                                                        }}

                                                    />
                                                )}
                                            />
                                        </div>
                                        {/*<div className="fields">*/}
                                        {/*    <label className="form-label">User</label>*/}
                                        {/*    <select*/}
                                        {/*        ref={ref => (inputRefs.current['txtUserCode'] = ref)}*/}
                                        {/*        id="inputState"*/}
                                        {/*        className="form-select"*/}
                                        {/*        value={formData.UserCode}*/}
                                        {/*        onChange={(e) => {*/}
                                        {/*            setFormData({ ...formData, UserCode: e.target.value })  */}
                                                   
                                        {/*        }}*/}
                                        {/*        onKeyDown={(e) => {*/}
                                        {/*            if (e.key === 'Enter') {*/}
                                        {/*                handleSubmit()*/}
                                        {/*            };*/}
                                        {/*        }}*/}
                                        {/*    >*/}
                                        {/*        <option>Please Select User</option>*/}
                                        {/*        {*/}
                                        {/*            userCodedropdown?.map((item, index) => {*/}
                                        {/*                return (*/}
                                        {/*                    <option key={index} value={item.valuePart}>{item.textPart}</option>*/}
                                        {/*                )*/}
                                        {/*            })*/}
                                        {/*        }*/}
                                        {/*    </select>*/}
                                        {/*</div>*/}
                                    </div>
                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn info" onClick={handleSubmit}>
                                                <i className="fa fa-search" />  Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <UploadDataReportTable loading={isLoading} handleReset={handleClear} handleClick={handleClick} setColoredRow={setColoredRow} ColoredRow={ColoredRow} currentPageNo={currentPageNo} tableData={tableData} handleChange={handleChange1} />

            <ToastContainer theme='colored' />
         
            {SessionClear ? <ClearSession /> : <></>}
            <Footer/>
        </>
    )
}
export default UploadDataReportForm






